var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stage)?_c('div',{staticClass:"app-ploter-widget-scale"},[_c('div',{staticClass:"enlarge-btn",on:{"click":_vm.onScaleEnlarge}}),_vm._v(" "),_c('div',{staticClass:"narrow-btn",on:{"click":_vm.onScaleNarrow}}),_vm._v(" "),_c('div',{staticClass:"reset-btn",on:{"click":_vm.onResetScale}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72506040","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/exhibition/ploter/widget/Scale.vue
// module id = null
// module chunks = 